export default {
  background: 'linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%)'
};
